import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

const BASE_PATH = "/internal_api/circle_ai/bot_conversations";

export const circleAiBotConversations = {
  index: ({ params = {} }: { params?: Params } = {}) =>
    buildPath(BASE_PATH, params),
  show: ({ uuid, params = {} }: { uuid: string; params?: Params }) =>
    buildPath(`${BASE_PATH}/${uuid}`, params),
  toolCall: ({ uuid, toolCallId }: { uuid: string; toolCallId: string }) =>
    buildPath(`${BASE_PATH}/${uuid}/tool_calls/${toolCallId}`),
};
